import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { STORAGE_CONFIG } from './app/app.module';
import { AppComponent } from './app/app.component';
import { NgxsStoragePluginModule, NgxsStoragePluginOptions, StorageOption, withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { NgxsEmitPluginModule } from '@ngxs-labs/emitter';
import { AppState } from './app/states/AppState';
import { CurrentApplicationState } from './app/states/CurrentApplicationState';
import { ServiceInfoState } from './app/states/ServiceInfoState';
import { BasicInfoState } from './app/states/BasicInfoState';
import { PaymentInfoState } from './app/states/PaymentInfoState';
import { SelectedProductState } from './app/states/SelectedProductState';
import { FinancialInfoState } from './app/states/FinancialInfoState';
import { BankInfoState } from './app/states/BankInfoState';
import { LegitimationInfoState } from './app/states/LegitimationInfoState';
import { ContactInfoState } from './app/states/ContactInfoState';
import { PersonalInfoState } from './app/states/PersonalInfoState';
import { CurrentErrorState } from './app/states/CurrentErrorState';
import { NGXS_PLUGINS, NgxsModule, provideStore } from '@ngxs/store';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { KeycloakService, KeycloakAngularModule } from 'keycloak-angular';
import { APP_INITIALIZER, importProvidersFrom } from '@angular/core';
import { GlobalLoaderHttpInterceptor } from './app/interceptors/global-loader-interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { GlobalLoaderService } from './app/services/global-loader.service';
import { ProductPipe } from './app/pipes/product.pipe';
import { ConditionPipe } from './app/pipes/condition.pipe';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { BootstrapValidationDirective } from './app/directives/bootstrap-validation.directive';
import { ApiConnectorService } from './app/services/api-connector.service';
import { withNgxsFormPlugin } from '@ngxs/form-plugin';
import { withNgxsReduxDevtoolsPlugin } from '@ngxs/devtools-plugin';
import { withNgxsLoggerPlugin } from '@ngxs/logger-plugin';
import { resetPlugin } from './app/state/reset.reducer';

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: environment.keycloak,
      initOptions: {
        checkLoginIframe: false,
        onLoad: 'login-required',
      },
    });
}




bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(KeycloakAngularModule, BrowserModule, AppRoutingModule, ReactiveFormsModule, NgSelectModule, CurrencyMaskModule, NgbModule, NgxDropzoneModule, NgxsModule.forRoot([
            CurrentErrorState,
            PersonalInfoState,
            ContactInfoState,
            LegitimationInfoState,
            BankInfoState,
            FinancialInfoState,
            SelectedProductState,
            PaymentInfoState,
            BasicInfoState,
            ServiceInfoState,
            CurrentApplicationState,
            AppState,

        ]), NgxsEmitPluginModule.forRoot(), NgxsStoragePluginModule.forRoot(STORAGE_CONFIG)),
         provideStore(
      [],
      withNgxsFormPlugin(),
      withNgxsStoragePlugin({
        keys: '*',
        storage: StorageOption.SessionStorage,
      }),
      withNgxsReduxDevtoolsPlugin({ disabled: environment.name === 'prd' }),
      withNgxsLoggerPlugin()
    ),
    { provide: NGXS_PLUGINS, useValue: resetPlugin, multi: true },
        ConditionPipe,
        ProductPipe,
        ApiConnectorService,
        BootstrapValidationDirective,
        GlobalLoaderService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GlobalLoaderHttpInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeKeycloak,
            multi: true,
            deps: [KeycloakService],
        },
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
  .catch(err => console.error(err));
